import * as styles from './styles.css';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { Wrapper } from 'shared/components/Wrapper';
import { LIST } from './constants';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const ServicesForBuyers: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.ServicesBuyers}>
          <TextInfoWithImage list={LIST} image="focus-house" title="Сервисы для покупателей" />
        </Element>
      </Wrapper>
    </div>
  );
};
